<script>

export default {
	components: {},
	props: ['id', 'firstRows', 'columns'],
	data() {
		return {
			availableFields: [
				'name',
				'ean',
				'product_line',
				'manufacturer',
				'package_size',
				'purchase_price',
				'selling_price',
				'quantity'
			],
			selectedFields: [],
			errors: {},
			submitDisabled: true,
			isLoading: false
		}
	},
	beforeMount() {

		for (let j = 0; j < this.columns; j++) {
			this.selectedFields[j] = 'no_import';
		}

		for (let j = 0; j < this.firstRows[0].length; j++) {

			let fieldKey = this.firstRows[0][j];

			if (fieldKey === 'Tuotteen nimi' || fieldKey === 'name') {
				this.fieldSelected(j, 'name');
			} else if (fieldKey === 'Viivakoodi' || fieldKey === 'ean') {
				this.fieldSelected(j, 'ean');
			} else if (fieldKey === 'Tuotesarja' || fieldKey === 'product_line') {
				this.fieldSelected(j, 'product_line');
			} else if (fieldKey === 'Valmistaja' || fieldKey === 'manufacturer') {
				this.fieldSelected(j, 'manufacturer');
			} else if (fieldKey === 'Pakkauskoko' || fieldKey === 'package_size') {
				this.fieldSelected(j, 'package_size');
			} else if (fieldKey === 'Sisäänostohinta' || fieldKey === 'purchase_price') {
				this.fieldSelected(j, 'purchase_price');
			} else if (fieldKey === 'Hinta' || fieldKey === 'selling_price') {
				this.fieldSelected(j, 'selling_price');
			} else if (fieldKey === 'Varasto' || fieldKey === 'quantity') {
				this.fieldSelected(j, 'quantity');
			}

		}

	},
	methods: {
		reset()
		{
			$('#confirmationRestartModal').modal('toggle');
		},
		async onConfirm() {

			this.isLoading = true;

			await axios.post('/import-products/' + this.id + '/map-fields', {fields: this.selectedFields}).then(response => {

				window.location = '/import/' + this.id +  '/handle-invalid-rows';

			}).catch(error => {

				if (error && error.response.status === 422 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

				this.isLoading = false;

			});

		},
		fieldSelected(index, value) {

			for (let i = 0; i < this.selectedFields.length; i++) {

				if (index !== i && this.selectedFields[i] === value && value !== 'no-import') {
					this.selectedFields[i] = null;
				}

			}

			this.selectedFields[index] = value;

			this.submitDisabled = false;

			if (this.selectedFields.includes('name') === false) {
				this.submitDisabled = true;
				return;
			}

			if (this.selectedFields.includes('selling_price') === false) {
				this.submitDisabled = true;
				return;
			}

		}
	}
}

</script>